import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import vuetify from './plugins/vuetify';
import * as firebase from 'firebase';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './registerServiceWorker'
import AlertCmp from "./components/Alert"
import CardTileCmp from "./components/CardTile"

Vue.component("app-alert", AlertCmp);
Vue.component("card-tile", CardTileCmp);

Vue.config.productionTip = false;

firebase.initializeApp({
    apiKey: "AIzaSyCYTYP_cdk7aRbeSpBSO9qlCjhMheyW_6o",
    authDomain: "redemptiondb.firebaseapp.com",
    databaseURL: "https://redemptiondb.firebaseio.com",
    projectId: "redemptiondb",
    storageBucket: "redemptiondb.appspot.com",
    messagingSenderId: "652402484312",
    appId: "1:652402484312:web:c84eae50f207be4f1dd62d",
    measurementId: "G-DTXERQ0V2K"
});

firebase.firestore().settings({
    cacheSizeBytes: firebase.database().CACHE_SIZE_UNLIMITED
});

firebase.firestore().enablePersistence()
    .catch(function (err) {
        if (err.code === 'failed-precondition') {
            console.log(err);
            // Multiple tabs open, persistence can only be enabled
            // in one tab at a a time.
            // ...
        } else if (err.code === 'unimplemented') {
            console.log(err);
            // The current browser does not support all of the
            // features required to enable persistence
            // ...
        }
    });

firebase.auth().setPersistence("none").catch(err => {
    console.log("persistence error: ", err);
});

// keeps user object in-sync with firebase auth state
let unsubscribe = firebase.auth().onAuthStateChanged(user => {
    store.commit("setIsUserLoggedIn", user !== null);
    console.log("auth state changed, user: ", user);
    if (user) {
        store.commit("setUser", user);
        // store.dispatch("downloadUserData", user.uid);
    }
    if (!store.getters.getIsUserLoggedIn) {
        store.commit("setIsUserDataLoaded", false);
    }
});

new Vue({
    vuetify,
    router,
    store,
    firebase,
    render: h => h(App),
    destroy() {
        unsubscribe();
    }
}).$mount('#app');



